import store from '@/store/store'
import axios from 'axios'
import axiosAuth from './Flotex/auth'
import jwt from './jwt'

const _http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/ld+json',
    'Content-Type': 'application/ld+json'
  }
})

// _http.defaults.timeout = 15000;

// https://hackernoon.com/lets-make-a-javascript-wait-function-fa3a2eb88f11
var wait = (ms) => new Promise((r) => setTimeout(r, ms))

// Request interceptor
_http.interceptors.request.use(
  async (reqConfig) => {
    // JWT not available or invalid
    if (!jwt.isValid()) {
      // Try refreshing JWT if it isn't being refreshed already
      if (!_http.isRefreshingJWT) {
        _http.isRefreshingJWT = true
        // Refresh token
        axiosAuth
          .login(process.env.VUE_APP_USERNAME, process.env.VUE_APP_PASSWORD)
          .finally((r) => {
            // Refresh token attempt finished
            _http.isRefreshingJWT = false
            return r
          })

        // axiosAuth
        //   .refresh()
        //   .catch(() => {
        //     // To tylko w tej aplikacji. Normalnie nie ma danych autoryzacyjnych i docelowo tutaj tez raczej nie bedzie.
        //     // Refresh token failed, try auth
        //     return axiosAuth.login(
        //       process.env.VUE_APP_USERNAME,
        //       process.env.VUE_APP_PASSWORD
        //     )
        //   })
        //   .finally((r) => {
        //     // Refresh token attempt finished
        //     _http.isRefreshingJWT = false
        //     return r
        //   })
      }

      // Wait for token refresh to finish
      while (_http.isRefreshingJWT) {
        // console.log('waiting for refresh: ' + reqConfig.url )
        await wait(400)
      }
    }

    // If valid JWT exist set axios header
    if (jwt.isValid()) {
      reqConfig.headers.Authorization = 'Bearer ' + jwt.getToken()
    }
    // else {
    //   // Rozwarzyć anulowanie żądań gdy brak tokenu JWT
    //   throw new axios.Cancel('Operation canceled by the user.');
    // }
    return reqConfig
  },
  (err) => Promise.reject(err)
)

// Response interceptor
_http.interceptors.response.use(
  (response) => {
    // Return a successful response back to the calling service
    return response
  },
  (error) => {
    if (error.isAxiosError && 'Network Error' === error.message) {
      store.set('error/errorNetwork', true)
    }

    if (error.isAxiosError && error.response && error.response.status === 404) {
      store.set('error/error404', true)
    }

    if (error.isAxiosError && error.response && error.response.status >= 500) {
      store.set('error/error5xx', true)
    }

    // if (error.isAxiosError && error.response && error.response.status === 400) {
    //   if (
    //     error.response.data &&
    //     typeof error.response.data["violations"] !== "undefined"
    //   ) {
    //     store.set("error/errorValidation", true);
    //   }
    // }

    // console.log([error.isAxiosError, error.message, error, error.response])

    return Promise.reject(error)
  }
)

// -----------------------------------------
// Loader storage interceptors
_http.interceptors.request.use(
  (config) => {
    store.commit('loader/START_LOADING')
    return config
  },
  (error) => {
    store.commit('loader/FINISH_LOADING')
    return Promise.reject(error)
  }
)

_http.interceptors.response.use(
  (response) => {
    store.commit('loader/FINISH_LOADING')
    return response
  },
  (error) => {
    store.commit('loader/FINISH_LOADING')
    return Promise.reject(error)
  }
)

export default _http
